import React, {useEffect, useState} from "react";
import ReactDOM from "react-dom";

import App from "./App";
import "antd/dist/antd.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createStore, applyMiddleware } from "redux";
import ThunkMiddleware from "redux-thunk";
import { Provider } from "react-redux";
import reducer from "./redux/reducer";
import {ErrorBoundary} from "react-error-boundary";
import ErrorPage from "./modules/shared/components/error/ErrorPage";
import {useNavigate} from "react-router-dom";
import setupI18n from "./i18n";
import LoadingPage from "./modules/shared/components/loading/LoadingPage";

// Function to fetch configuration

const fetchedItem = localStorage.getItem("reduxState");
const persistedState = localStorage.getItem("reduxState")
  ? JSON.parse(fetchedItem !== null ? fetchedItem : "")
  : {};

export const store = createStore(
  reducer,
  persistedState,
  applyMiddleware(ThunkMiddleware)
);

store.subscribe(() => {
  localStorage.setItem("reduxState", JSON.stringify(store.getState()));
});

const EntryPoint = () => {
    const [isInitialized, setIsInitialized] = useState(false);

    const initConfig = async () => {
        try {
            const response = await fetch('/config.json');
            const config = await response.json();
            window.AppConfig = config;
            await setupI18n();
        } catch (error) {
            console.error('Failed to load the app configuration:', error);
        }
    };
    
    useEffect(() => {
        initConfig().then(() => {
            setIsInitialized(true);
        });
    }, []);

    if (!isInitialized) {
        return <LoadingPage />;
    }

    return (
        <Provider store={store}>
            <ErrorBoundary
                FallbackComponent={ErrorPage}
                onReset={() => {
                    window.history.go(0);
                }}>
                <App />
            </ErrorBoundary>
        </Provider>
    );
};

ReactDOM.render(
    <EntryPoint />,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
